import React from 'react';

import styled from 'styled-components';
import { palette } from 'theme/MainTheme';

const HelperText = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	img {
		width: 150px;
		height: auto;
		margin-bottom: 30px;
	}

	h3 {
		font-size: 18px;
		font-weight: 500;
		color: ${palette('text', 2)};
		margin: 0;
	}
`;

const NoApiKeyImg = ({ width = '100%', height = '40vh', NoApiKeyImg }) => (
	<HelperText className='isoHelperText' style={{ width, height }}>
		<img alt='#' src={NoApiKeyImg} />
		<h3>Please Enter Your API Key in the `src/settings/index.js`</h3>
	</HelperText>
);
export default NoApiKeyImg;
